import { SocialChannel } from "../View";

// ─── Default social media channels ─────────────────────
export const DEFAULT_SOCIAL_CHANNELS: SocialChannel[] = [
    { key: "instagram", label: "Instagram", url: "", enabled: true },
    { key: "facebook", label: "Facebook", url: "", enabled: false },
    { key: "tiktok", label: "TikTok", url: "", enabled: false },
    { key: "x", label: "X (Twitter)", url: "", enabled: false },
    { key: "linkedin", label: "LinkedIn", url: "", enabled: false },
    { key: "youtube", label: "YouTube", url: "", enabled: false },
];
